

export default (currency) => {
    const items = {
        'euro':'€',
        'grn':'₴',
    }
    
    return items[currency]
}